import { Component, Input, OnInit } from '@angular/core';
import { IDraftPortfolioOut } from 'src/models/products.model';
import { DraftInvestmentRoute } from 'src/models/routes.model';

@Component({
  selector: 'liberro-draft-card',
  standalone: false,
  templateUrl: './liberro-draft-card.component.html',
  styleUrl: './liberro-draft-card.component.less'
})
export class LiberroDraftCardComponent implements OnInit {
  @Input({required: true}) public draft!: IDraftPortfolioOut;

  public draftUrl: string[] = [];

  public ngOnInit(): void {
    this.draftUrl = ['/', DraftInvestmentRoute.DRAFT_INVESTMENT, DraftInvestmentRoute.DETAIL, this.draft!.draftPortfolioId.toString()]
  }

}
